<div class="page-container gap-24 font-color-black">
  <div class="page-title">DATENSCHUTZERKLÄRUNG „INSTITUT WISSEN“</div>
  <div class="flex-c gap-24">
    <span class="title-level-2">A. ALLGEMEINE INFORMATIONEN</span>
    <div class="flex-c gap-8">
      <span class="title-level-3"> 1. INHALT DIESER DATENSCHUTZERKLÄRUNG </span>
      <span class="font-regular-body-large">
        Die Institut Wissen InWi gemeinnützige UG (nachfolgend auch
        <span class="font-bold-body-large">„Verantwortlicher“</span>), speichert
        und verarbeitet personenbezogene Daten, wie in dieser
        Datenschutzerklärung beschrieben, von Besucher:innen und Nutzer:innen
        der Fortbildungsplattform
        <a href="https://wissen.institute" target="_blank">
          www.wissen.institute
        </a>
        (nachfolgend
        <span class="font-bold-body-large">„Webauftritt“</span>
        oder
        <span class="font-bold-body-large">„Plattform“</span>).
        <br />
        <br />
        Die in dieser Datenschutzerklärung aufgeführten personenbezogenen Daten
        werden nur von dem Verantwortlichen und in dieser Datenschutzerklärung
        benannten Dritten verarbeitet. Darüber hinaus gibt der Verantwortliche
        personenbezogene Daten in der Regel nicht an sonstige Dritte weiter.
        Eine Weitergabe personenbezogener Daten an sonstige Dritte erfolgt nur
        in dem Ausnahmefall, dass der Verantwortliche aufgrund einer
        behördlichen oder gerichtlichen Anordnung hierzu verpflichtet ist.
        <br />
        <br />
        Soweit im Rahmen der Plattform auf die Angebote Dritter verlinkt wird,
        gelten hierfür die Datenschutzbestimmungen dieser Dritten.
      </span>
    </div>

    <div class="flex-c gap-8">
      <span class="title-level-3">
        2. VERANTWORTLICH GEMÄSS ART. 4 NR. 7 DSGVO
      </span>
      <span class="font-regular-body-large">
        Verantwortlich für die in dieser Datenschutzerklärung beschriebene
        Datenverarbeitung ist gemäß Art. 4 Nr. 7 EU-Datenschutzgrundverordnung
        (Verordnung (EU) 2016/679) (nachfolgend auch
        <span class="font-bold-body-large">„DSGVO“</span>) der
        <br />
        <br />
        Institut Wissen gemeinnützige UG (haftungsbeschränkt)
        <br />
        Kreuzstraße 7
        <br />
        77716 Hofstetten
        <br />
        <br />
        E-Mail: kontakt&#64;wissen.institute Weitere Informationen zum
        Verantwortlichen erhalten Sie auch im Impressum.
      </span>
    </div>
    <div class="flex-c gap-8">
      <span class="title-level-3"> 3. DATENSCHUTZBEAUFTRAGTE(R) </span>
    </div>
    <div class="flex-c gap-8">
      <span class="title-level-3"> 4. RECHTE VON BETROFFENEN PERSONEN </span>
      <span class="font-regular-body-large">
        Nach Maßgabe der DSGVO sowie nach Maßgabe der einschlägigen Vorschriften
        des Unionsrechts und des nationalen Rechts stehen Ihnen im Umfang der
        jeweiligen Vorschrift folgende Rechte zu, die Sie gegenüber dem
        Verantwortlichen z.B. durch eine Nachricht an an die unter Ziffer 2.
        genannten Kontaktdaten geltend machen können. Der Verantwortliche wird
        Ihre Rechte erfüllen, wenn die entsprechenden Voraussetzungen hierfür
        vorliegen:
        <br />
        <br />
        Jede betroffene Person hat:
        <ol>
          <li>das Recht auf Auskunft nach Art. 15 DSGVO,</li>
          <li>das Recht auf Berichtigung nach Art. 16 DSGVO,</li>
          <li>
            das Recht auf Einschränkung der Verarbeitung nach Art. 18 DSGVO
            sowie
          </li>
          <li>das Recht auf Datenübertragbarkeit aus Art. 20 DSGVO.</li>
        </ol>
        Ferner können Einwilligungen jederzeit mit Wirkung für die Zukunft gemäß
        Art. 7 Abs. 3 DSGVO widerrufen werden. Wir weisen jedoch darauf hin,
        dass in dem Fall unsere Plattform unter Umständen nicht mehr voll
        umfänglich in Anspruch genommen werden können.
        <br />
        <br />
        Die vorstehend genannten Rechte können gegenüber dem Verantwortlichen
        durch Nachricht an die unter Ziffer 2. aufgeführten Kontaktdaten,
        insbesondere durch E-Mail an kontakt&#64;wissen.institute geltend
        gemacht werden.
        <br />
        <br />
        Darüber hinaus besteht ein Beschwerderecht bei einer
        Datenschutzaufsichtsbehörde (Art. 77 DSGVO i.V.m. § 19 BDSG).
        <br />
        <br />
        <span class="font-bold-body-large">
          Information über das Widerspruchsrecht nach Art. 21 DSGVO
        </span>
        Betroffene Personen haben weiterhin gemäß Art. 21 Abs. 1 DSGVO das
        Recht, aus Gründen, die sich aus ihrer besonderen Situation ergeben,
        jederzeit gegen die Verarbeitung sie betreffender personenbezogener
        Daten, die aufgrund von Artikel 6 Abs. 1 UAbs. 1 lit. e DSGVO
        (Datenverarbeitung im öffentlichen Interesse) und Artikel 6 Abs. 1 UAbs.
        1 lit. f DSGVO (Datenverarbeitung auf der Grundlage einer
        Interessenabwägung) erfolgt, Widerspruch einzulegen.
        <br />
        <br />
        Nach eingegangenem Widerspruch und Vorliegen der entsprechenden
        Voraussetzungen, werden wir die betroffenen personenbezogenen Daten
        nicht mehr verarbeiten, es sei denn, wir können zwingende schutzwürdige
        Gründe für die Verarbeitung nachweisen, die die Interessen, Rechte und
        Freiheiten der jeweils betroffenen Person überwiegen, oder die
        Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von
        Rechtsansprüchen.
        <br />
        <br />
        Der Widerspruch kann formfrei erfolgen und es fallen keine anderen als
        die Übermittlungskosten nach den Basistarifen an.
        <br />
        <br />
        Der Widerspruch ist, zu richten an:
        <br />
        <br />
        postalisch: Kreuzstraße 7, 77716 Hofstetten
        <br />
        <br />
        oder per E-Mail: kontakt&#64;wissen.institute
      </span>
    </div>
    <div class="flex-c gap-8">
      <span class="title-level-3"> 5. INTERNE VERARBEITUNG </span>
      <span class="font-regular-body-large">
        Wir verarbeiten die im Folgenden genannten personenbezogenen Daten im
        Rahmen von Verwaltungsaufgaben sowie zur Organisation unseres Betriebs,
        und zur Befolgung der gesetzlichen Pflichten, wie z.B. der Archivierung.
        Die Rechtsgrundlagen hierfür sind Art. 6 Abs. 1 UAbs. 1 lit. b, c oder f
        DSGVO. Der Zweck und unser Interesse an der Verarbeitung liegen
        demzufolge in der Aufrechterhaltung unserer Geschäftstätigkeiten, der
        Wahrnehmung unserer gesetzlichen Aufgaben und der Erbringung unserer
        vertraglichen Leistungen.
      </span>
    </div>
    <div class="flex-c gap-8">
      <span class="title-level-3">
        6. KEINE AUTOMATISIERTEN ENTSCHEIDUNGSFINDUNGEN
      </span>
      <span class="font-regular-body-large">
        Automatisierte Entscheidungsfindung i.S.d. Art. 22 DSGVO kommen im
        Rahmen der in dieser Datenschutzinformation beschriebenen
        Datenverarbeitungsprozesse nicht zum Einsatz.
      </span>
    </div>
    <div class="flex-c gap-8">
      <span class="title-level-3"> 7. SPEICHERDAUER </span>
      <span class="font-regular-body-large">
        Die in dieser Datenschutzinformation genannten personenbezogenen Daten
        werden von uns gelöscht bzw. zur Löschung durch unsere
        Auftragsverarbeiter (Abschnitt D) angewiesen, wenn sie für die
        vorgenannten Zwecke nicht mehr benötigt werden, sofern der Datenlöschung
        keine gesetzlichen Aufbewahrungspflichten entgegenstehen. Insbesondere
        beurteilt sich die Speicherdauer nach den gesetzlichen
        Verjährungsfristen, die zum Beispiel nach den §§ 195 ff. des
        Bürgerlichen Gesetzbuches (BGB) in der Regel 3 Jahre, in gewissen Fällen
        aber auch bis zu dreißig Jahre betragen können. Wir unterliegen
        insbesondere verschiedenen Aufbewahrungs- und Dokumentationspflichten,
        die sich unter anderem aus dem Sozialgesetzbuch Fünftes Buch (SGB V),
        Handelsgesetzbuch (HGB), der Abgabenordnung (AO), und dem
        Geldwäschegesetz (GwG) ergeben. Die dort vorgegebenen Fristen zur
        Aufbewahrung bzw. Dokumentation betragen zwei bis zehn Jahre.
      </span>
    </div>
    <span class="title-level-2">
      B. DATENVERARBEITUNG BEI BESUCH DER PLATTFORM
    </span>
    <div class="flex-c gap-8">
      <span class="title-level-3"> 1. LOGFILES </span>
      <span class="font-regular-body-large">
        Jeder Besuch unserer Plattform wird automatisch durch sogenannte
        „Logfiles“ protokolliert. Dabei werden die folgenden Daten erfasst:
        <ol>
          <li>Datum und Uhrzeit des Zugriffs,</li>
          <li>Website, von der aus der Zugriff erfolgt (Referrer-URL),</li>
          <li>Hostname des zugreifenden Rechners (IP-Adresse),</li>
          <li>Name und URL der abgerufenen Datei,</li>
          <li>die gekürzte IP-Adresse,</li>
          <li>
            verwendeter Browser und ggf. das Betriebssystem Ihres Rechners sowie
            der Name Ihres Access-Provider.
          </li>
        </ol>
        Die vorgenannten Daten sind für uns technisch erforderlich, um Ihnen
        unseren Webauftritt anzeigen und die Stabilität und Sicherheit
        gewährleisten zu können. Außerdem nutzen wir diese Daten zur
        statistischen Auswertung. Aus den vorgenannten Zwecken folgt auch unser
        berechtigtes Interesse im Sinne von Art. 6 Abs. 1 UAbs. 1 lit. f DSGVO.
        Die so erhobenen Daten sind Ihnen als bestimmter Person nicht
        zuordenbar. Eine Zusammenführung dieser Daten mit anderen Datenquellen
        wird nicht vorgenommen.
      </span>
    </div>
    <div class="flex-c gap-8">
      <span class="title-level-3">
        2. KONTAKTAUFNAHME UND THEMENVORSCHLÄGE
      </span>
      <span class="font-regular-body-large">
        Wenn Sie uns personenbezogene Daten über das Einreichungsformular auf
        unserer Plattform oder auf sonstigem Wege übermitteln, werden diese vom
        Verantwortlichen gemäß Art. 6 Abs. 1 UAbs. 1 lit. b DSGVO ausschließlich
        verwendet, um mit Ihnen Kontakt aufzunehmen und ggf. um Ihre Anfrage zu
        bearbeiten.
        <br />
        <br />
        Sie können uns über ein Kontaktformular Themenvorschläge senden. Sollten
        Sie nicht bereits ein Nutzerkonto haben (siehe Abschnitt C), bitten wir
        Sie um Angabe Ihrer E-Mail-Adresse. Diese Verarbeitung erfolgt gemäß
        Art. 6 Abs. 1 UAbs. 1 lit. f DSGVO aufgrund unseres berechtigten
        Interesses an den im Folgenden beschriebenen Verwendungszwecken: Die
        Angabe Ihrer E-Mail-Adresse hilft uns zum einen, uns vor Spam zu
        schützen. Daneben können wir die E-Mail-Adresse auch dafür nutzen, mit
        Ihnen Kontakt aufzunehmen, um Sie über interne Entwicklungen zu Ihrem
        Themenvorschlag zu informieren. Wir behalten uns vor, Ihnen in dem Fall
        auch einen Gutschein für die Seminarbuchung auf unserer Website zu
        übermitteln. Ein Anspruch auf einen Gutschein gegenüber dem
        Verantwortlichen besteht nicht. Die Nutzung Ihrer E-Mail-Adresse zum
        Zweck der Kontaktaufnahme können Sie jederzeit widersprechen, ohne dass
        Ihnen hierfür andere als die Übermittlungskosten nach den Basistarifen
        entstehen.
      </span>
    </div>
    <div class="flex-c gap-8">
      <span class="title-level-3"> 3. COOKIES UND ÄHNLICHE TECHNOLOGIEN </span>
      <span class="font-regular-body-large">
        Auf unserem Webauftritt kommen Cookies und ähnliche Technologien zum
        Einsatz.
        <br />
        <br />
        Cookies sind kleine Textdateien oder andere Speichertechnologien, die
        durch den von Ihnen eingesetzten Internet-Browser auf Ihrem Endgerät
        ablegt und gespeichert werden.
        <br />
        <br />
        Wir verwenden auf unserer Plattform sog. Session-Cookies (auch temporäre
        oder Sitzungs-Cookies genannt). Diese Session-Cookies werden
        ausschließlich für die Dauer Ihrer Nutzung unserer Plattform gespeichert
        und mit Schießen des Browsers gelöscht.
        <br />
        <br />
        Teilweise werden auf unserem Webauftritt auch Permanente Cookies von
        Drittunternehmen, mit denen wir zusammenarbeiten, verwendet. Solche
        Cookies werden unabhängig davon gespeichert, ob Sie Ihren Browser
        schließen. Die Speicherdauer ist dabei unterschiedlich. Die Einzelheiten
        hierzu, insbesondere zu den Zwecken und den Rechtsgrundlagen der
        Verarbeitung solcher Drittanbieter-Cookies, entnehmen Sie bitte
        Abschnitt D.
      </span>
    </div>
    <div class="flex-c gap-8">
      <span class="title-level-3"> 4. NEWSLETTER </span>
      <span class="font-regular-body-large">
        Personen, die sich mit ihrer E-Mail-Adresse für den Newsletter anmelden,
        informieren wir über zukünftige Webinare und Seminare sowie
        Rabattaktionen, Forschungsergebnisse und Leitlinienupdates sowie
        Kooperationspartner.
        <br />
        <br />
        Pflichtangabe für die Übersendung des Newsletters ist allein eine
        gültige E-Mail-Adresse, die Verarbeitung erfolgt gemäß § Art. 6 Abs. 1
        UAbs. 1 lit.b DSGVO. Sofern der Newsletter über den Nutzeraccount
        (Abschnitt C) angemeldet wird, werden wir den dort hinterlegten Namen
        für eine personalisierte Ansprache verwenden.
        <br />
        <br />
        Für die Anmeldung zu unserem Newsletter verwenden wir das sog.
        Double-opt-in-Verfahren. Das heißt, dass wir nach Anmeldung eine E-Mail
        an die angegebene E-Mail-Adresse senden, in welcher wir den/die
        Empfänger:in um Bestätigung bitten, dass er/sie den Versand des
        Newsletters wünscht. Wird die Anmeldung nicht [innerhalb von 24 Stunden]
        bestätigt, wird die jeweilige E-Mail-Adresse gelöscht. Darüber hinaus
        speichern wir jeweils die eingesetzten IP-Adressen und Zeitpunkte der
        Anmeldung und Bestätigung. Zweck des Verfahrens ist, die jeweilige
        Einwilligung zu dokumentieren (Art. 7 Abs. 1 DSGVO) und ggf. einen
        möglichen Missbrauch von personenbezogenen Daten aufklären zu können
        („berechtigtes Interesse“ i. S. v. § Art. 6 Abs. 1 UAbs. 1 lit.f DSGVO).
        Am Ende eines jeden Newsletters findet sich ein Link, über den der
        Newsletter jederzeit abbestellt werden kann. Bei Abbestellung des
        Newsletters werden die personenbezogenen Daten, die zum Zweck der
        Bereitstellung des Newsletters gespeichert wurden, gelöscht, sofern
        keine gesetzliche Aufbewahrungspflicht entgegensteht.
        <br />
        <br />
        Die Newsletter enthalten einen sogenannte „web beacon“, d.h. eine
        pixelgroße Datei, über die technische Informationen zum verwendeten
        Browser und Betriebssystem der Abonnent:innen, als auch die jeweilige
        IP-Adresse und der Zeitpunkt des jeweiligen Abrufs des Newsletters,
        verarbeitet werden. Diese Informationen nutzen wir auch um die
        Interessen der Abonnent:innen besser verstehen zu können und unsere
        Newsletter und deren Inhalte verbessern zu können. Der Einsatz solcher
        web beacon erfolgt auf Grundlage der jeweiligen Einwilligung gemäß § 25
        Abs. 2 Telekommunikation-Digitale-Dienste-Datenschutz-Gesetz (TDDDG).
        <br />
        <br />
        Rechtsgrundlage für den Versand und die Auswertung des
        Nutzungsverhaltens der Abonnent:innen ist die jeweilige Einwilligung
        gemäß Art. 6 Abs. 1 UAbs. 1 lit. a DSGVO. Diese Einwilligung kann für
        den Einsatz der Web Beacon, den Empfang des Newsletters und die
        Auswertung des Nutzungsverhaltens nur gemeinsam mit Wirkung für die
        Zukunft widerrufen werden.
      </span>
    </div>
    <span class="title-level-2">
      C. NUTZUNG DER PLATTFORM MIT NUTZERACCOUNT
    </span>
    <div class="flex-c gap-8">
      <span class="title-level-3"> 1. REGISTRIERUNG </span>
      <span class="font-regular-body-large">
        Um die zusätzlichen Funktionen der Plattform nutzen zu können,
        insbesondere Seminare buchen und an solchen teilnehmen zu können, müssen
        Sie zunächst ein Nutzerprofil anlegen. Für die Registrierung benötigen
        wir gemäß Art. 6 Abs. 1 UAbs. 1 lit. b DSGVO Ihren Vor- und Nachnamen,
        Ihre E-Mail-Adresse sowie ein von Ihnen festgelegtes sicheres Passwort.
        <br />
        <br />
        Zusätzlich können Sie – bereits bei der Registrierung oder später –
        freiwillig die folgenden weiteren personenbezogenen Daten angeben:
        Anschrift und Geburtsdatum für die Ausstellung der Teilnahmebestätigung,
        Telefonnummer für eventuelle Kontaktaufnahme im Rahmen eines gebuchten
        Seminars (siehe auch folgende Ziff. 2).
      </span>
    </div>
    <div class="flex-c gap-8">
      <span class="title-level-3"> 2. BUCHUNG EINES SEMINARS </span>
      <span class="font-regular-body-large">
        Wenn Sie ein Seminar buchen, verarbeiten wir die folgenden
        personenbezogenen Daten:
        <br />
        2.1 zu Zwecken der Durchführung und Abrechnung des Seminars gemäß Art. 6
        Abs. 1 UAbs. 1 lit. b DSGVO:
        <ol>
          <li>Vor- und Nachname der Seminarteilnehmenden,</li>
          <li>Name des gebuchten Seminars,</li>
          <li>E-Mail-Adresse,</li>
          <li>
            für den Fall, dass die Teilnehmenden von einem Rabatt als
            BED-Mitglied profitieren wollen, die jeweilige BED-Mitgliedsnummer,
            wobei diese lediglich zum Zwecke der Verifizierung verarbeitet und
            anschließend wieder gelöscht wird,
          </li>
          <li>
            für den Fall, dass die Teilnehmenden von einem Frühbucherrabatt
            profitieren wollen die Information, dass das Seminar bis zu einem
            bestimmten Zeitpunkt gebucht wurde,
          </li>
          <li>
            für den Fall, dass die Teilnehmenden von einem Rabatt profitieren
            wollen, den für die Buchung angewendeten Gutschein- oder Promotion
            Code,
          </li>
          <li>Rechnungsadresse,</li>
        </ol>
        2.2 gemäß Art. 6 Abs. 1 UAbs. 1 lit. a DSGVO:
        <ol>
          <li>Anrede,</li>
          <li>
            auf Grundlage der Einwilligung von Seminarteilnehmenden, die für
            sich selbst ein Seminar buchen: Telefonnummer von
            Seminarteilnehmenden, damit wir diese im Falle ihrer Abwesenheit
            oder bei technischen Schwierigkeiten während eines Seminars anrufen
            können,
          </li>
          <li>
            auf Grundlage der Einwilligung der das Seminar buchenden Person:
          </li>
          <li>
            Telefonnummer der buchenden Person, um diese über die Abwesenheit
            der/des Seminarteilnehmenden zu informieren oder bei technischen
            Schwierigkeiten während eines Seminars anrufen können,
          </li>
          <li>Bemerkungen („Fragen vorab/Das interessiert mich besonders“),</li>
        </ol>
        2.3 zur Ausstellung einer Teilnahmebescheinigung gemäß Art. 6 Abs. 1
        UAbs. 1 lit. c DSGVO i. V. m. Anlage 4 zum Vertrag nach § 125 Abs. 1 SGB
        V:
        <ol>
          <li>Vor- und Nachname der Seminarteilnehmenden,</li>
          <li>Geburtsdatum der Seminarteilnehmenden</li>
          <li>Name/Thema des gebuchten Seminars,</li>
          <li>Kurzbeschreibung der maßgeblichen Fortbildungsinhalte,</li>
          <li>Veranstaltungsort,</li>
          <li>
            Anzahl der jeweils erhaltenen Unterrichteinheiten und ggf.
            Fortbildungspunkte.
          </li>
        </ol>
        Gemäß Anlage 4 zu den Verträgen nach § 125 SGB V führen wir als
        Veranstalter der Seminare für alle Veranstaltungen Teilnehmerlisten,
        welche für 60 Monate aufzubewahren sind.
      </span>
    </div>
    <div class="flex-c gap-8">
      <span class="title-level-3"> 3. TEILNAHME AN EINEM SEMINAR </span>
      <span class="font-bold-body-large">
        3.1 Online-Teilnahme an Seminaren („Webinare“)
      </span>
      <span class="font-regular-body-large">
        Webinare werden über das Tool „Zoom“ der Zoom Video Communications,
        Inc., die ihren Sitz in den USA hat, durchgeführt. Soweit Sie die
        Internetseite von „Zoom“ aufrufen, ist der Anbieter von „Zoom“ für die
        Datenverarbeitung verantwortlich. Ein Aufruf der Internetseite ist für
        die Nutzung von „Zoom“ jedoch nur erforderlich, um sich die Software für
        die Nutzung von „Zoom“ herunterzuladen. Webinarteilnehmende können
        „Zoom“ auch nutzen, wenn sie die jeweilige Meeting-ID und ggf. weitere
        Zugangsdaten zum Meeting direkt in der „Zoom“-App eingeben. Wenn sie die
        „Zoom“-App nicht nutzen wollen oder können, dann sind die
        Basisfunktionen auch über eine Browser-Version nutzbar, die sie
        ebenfalls auf der Website von „Zoom“ finden. Nähere Informationen zu
        diesem Anbieter finden Sie unter Abschnitt D Ziff. 3.
        <br />
        <br />
        Webinarteilnehmende können vor und während des Webinars durch
        entsprechende Einstellungen wählen, in welchem Umfang sie
        personenbezogene Daten mit anderen teilen wollen. Auch wenn die Angabe
        eines Namens für die Teilnahme am Webinar erforderlich ist, steht es den
        Teilnehmenden frei, ein Pseudonym zu verwenden. Im Übrigen können
        Teilnehmende die Videokonferenzen lediglich passiv verfolgen,
        insbesondere indem sie ihre Kameras und Mikrofone ausschalten und auch
        nicht die Chatfunktion verwenden.
        <br />
        <br />
        Der Verantwortliche wird die Webinare aufzeichnen und nach dem Webinar
        als Aufzeichnung auf der Plattform zum Abruf durch Seminarteilnehmende
        bereithalten, hierbei werden auch etwaige Interaktionen der
        Teilnehmenden aufgezeichnet. Wenn eine solche Aufzeichnung erfolgt, wird
        Teilnehmenden vorab mitgeteilt. Außerdem erfolgt ein entsprechender
        Hinweis in der Zoom-App. Etwaige personenbezogene Daten der
        Seminarteilnehmenden können nach Ablauf der erforderlichen Speicherdauer
        auf Anfrage der betroffenen Personen aus den Aufzeichnungen entfernt
        werden.
        <br />
        <br />
        Folgende personenbezogene Daten sind Gegenstand der Verarbeitung:
        <br />
        <br />
        (1) Zur Durchführung des Webinars gemäß Art. 6 Abs. 1 UAbs. 1 lit. b
        DSGVO
        <ol>
          <li>E-Mail-Adresse und Passwort des:der Webinarteilnehmenden,</li>
          <li>
            Bei Einwahl mit dem Telefon: Angabe zur eingehenden und ausgehenden
            Rufnummer, Ländername, Start- und Endzeit. Ggf. können weitere
            Verbindungsdaten wie z.B. die IP-Adresse des Geräts gespeichert
            werden,
          </li>
          <li>
            Bei Aufzeichnung des Webinars (Regelfall): MP4-Datei aller Video-,
            Audio- und Präsentationsaufnahmen, M4A-Datei aller Audioaufnahmen,
            Textdatei des Online-Meeting-Chats.
          </li>
        </ol>
        (2) zur Ausstellung einer Teilnahmebescheinigung gemäß Art. 6 Abs. 1
        UAbs. 1 lit. c DSGVO i. V. m. Anlage 4 zum Vertrag nach § 125 Abs. 1 SGB
        V:
        <ol>
          <li>
            Vor- und Nachnamen sowie das etwaig verwendete Pseudonym des:der
            Webinarteilnehmenden,
          </li>
          <li>Geburtsdatum der Webinarteilnehmenden,</li>
          <li>E-Mail-Adresse des:der Webinarteilnehmenden,</li>
          <li>
            Information über die Anwesenheit des:der Teilnehmenden am Webinar
            („Logging“),
          </li>
        </ol>
        (3) auf Grundlage der Einwilligung der Webinarteilnehmenden gemäß Art. 6
        Abs. 1 UAbs. 1 lit. a DSGVO:
        <ol>
          <li>Telefonnummer,</li>
          <li>Profilbild,</li>
          <li>
            Text-, Audio- und Videodaten, soweit Teilnehmende die Chat-, Fragen-
            oder Umfragenfunktionen nutzen. Wenn Webinarteilnehmende bei „Zoom“
            als Benutzer registriert sind, dann können Berichte über
            „Online-Meetings“ (Meeting-Metadaten, Daten zur Telefoneinwahl,
            Fragen und Antworten in Webinaren, Umfragefunktion in Webinaren) bis
            zu 12 Monate bei „Zoom“ gespeichert werden.
          </li>
        </ol>
      </span>
      <span class="font-bold-body-large">
        3.2 Teilnahme an Präsenzveranstaltungen
      </span>
      <span class="font-regular-body-large">
        Wird ein Seminar (auch) in Präsenz der Seminarteilnehmenden verarbeitet,
        verarbeitet der Verantwortliche die folgenden personenbezogenen Daten
        zur Ausstellung einer Teilnahmebescheinigung gemäß Art. 6 Abs. 1 UAbs. 1
        lit. c DSGVO i. V. m. Anlage 4 zum Vertrag nach § 125 Abs. 1 SGB V:
        <ol>
          <li>Vor- und Nachname der Seminarteilnehmenden,</li>

          <li>Geburtsdatum der Seminarteilnehmenden,</li>
          <li>
            Information über die Anwesenheit des:der Seminarteilnehmenden.
          </li>
        </ol>
      </span>
    </div>
    <div class="flex-c gap-8">
      <span class="title-level-3"> 4. EVALUATION DES SEMINARS </span>
      <span class="font-regular-body-large">
        Im Anschluss an das Seminar haben Teilnehmende die Möglichkeit zur
        anonymen Evaluation. Hierzu wird den Teilnehmenden im Anschluss an das
        Seminar ein Link per E-Mail zugesandt. Wir sind bei Ausstellung einer
        Teilnahmebescheinigung nach Anlage 4 zu den Verträgen nach §125 SGB V
        verpflichtet, die Evaluation 60 Monate mindestens in elektronischer Form
        aufzubewahren.
      </span>
    </div>
    <span class="title-level-2"> D. EINSATZ VON AUFTRAGSVERARBEITERN </span>
    <div class="flex-c gap-8">
      <span class="font-regular-body-large">
        Sofern wir uns bei der Verarbeitung Ihrer personenbezogenen Daten der
        Hilfe von Dritten bedienen, erfolgt dies im Rahmen einer sogenannten
        Auftragsverarbeitung. Die jeweiligen Auftragsverarbeiter verarbeiten
        etwaig durch uns übermittelte Daten ausschließlich aufgrund unserer
        Weisungen und nach Maßgabe eines zu diesem Zweck jeweils geschlossenen
        Auftragsverarbeitungsvertrag. Solche Auftragsverarbeiter können
        insbesondere IT-, Marketing- und Infrastrukturdienstleister sein.
      </span>
    </div>
    <div class="flex-c gap-8">
      <span class="title-level-3">
        1. NEWSLETTER UND AUTOMATISIERTE E-MAILS
      </span>
      <span class="font-regular-body-large">
        Wir nutzen Brevo (früher Sendinblue), eine Plattform der Brevo GmbH, um
        Ihnen Newsletter und automatisierte E-Mails zukommen zu lassen. Die von
        Ihnen im Rahmen der Newsletteranmeldung und anderer Dienste angegebenen
        Daten werden auf den Servern von Brevo gespeichert und verarbeitet.
        <br />
        <br />
        1. Art und Umfang der Datenverarbeitung Bei der Anmeldung zu unserem
        Newsletter oder bei der Nutzung unserer Dienste übermitteln Sie uns Ihre
        E-Mail-Adresse und Ihren Namen sowie gegebenenfalls weitere freiwillige
        Angaben, die wir ausschließlich zur Personalisierung der Inhalte
        verwenden. Diese Daten werden auf Servern von Brevo gespeichert und
        verarbeitet, um Ihnen gezielte Informationen und Updates zukommen zu
        lassen.
        <br />
        <br />
        2. Zweck der Datenverarbeitung Die Speicherung und Verarbeitung der
        Daten erfolgt ausschließlich für die Bereitstellung und den Versand
        unseres Newsletters und automatisierter E-Mails. Hierzu zählen
        Informationen über neue Produkte, Aktionen oder relevante Neuigkeiten,
        die für Sie von Interesse sein könnten.
        <br />
        <br />
        3. Rechtsgrundlage Die Verarbeitung der E-Mail-Adresse und anderer
        freiwilliger Angaben erfolgt auf Grundlage Ihrer Einwilligung gemäß Art.
        6 Abs. 1 lit. a DSGVO. Sie können Ihre Einwilligung jederzeit
        widerrufen, indem Sie sich vom Newsletter abmelden. Den Abmeldelink
        finden Sie am Ende jedes Newsletters.
        <br />
        <br />
        4. Weitergabe an Dritte Ihre Daten werden nur im Rahmen unserer
        Dienstleistung und im Einklang mit den Datenschutzgesetzen weitergegeben
        und von Brevo in unserem Auftrag verarbeitet. Brevo verarbeitet die
        Daten ausschließlich innerhalb der EU und stellt durch technische und
        organisatorische Maßnahmen sicher, dass Ihre Daten geschützt sind.
        <br />
        <br />
        5. Speicherdauer Die Daten werden solange gespeichert, wie Sie für den
        Newsletter angemeldet sind. Nach Abmeldung vom Newsletter werden Ihre
        Daten zeitnah gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten
        bestehen.
      </span>
    </div>
    <div class="flex-c gap-8">
      <span class="title-level-3"> 2. ZOOM (VIDEOKONFERENZ) </span>
      <span class="font-regular-body-large">
        Wir nutzen für die Durchführung unserer Webinare den Dienst „Zoom“,
        bereitgestellt von der Zoom Video Communications, Inc., einem
        US-amerikanischen Anbieter.
        <br />
        <br />
        1. Art und Umfang der Datenverarbeitung Wenn Sie an einem unserer
        Webinare teilnehmen, werden Ihre Daten (Name, E-Mail-Adresse, technische
        Informationen wie IP-Adresse und Gerätedaten) von Zoom erfasst. Der
        Umfang der Daten hängt dabei auch davon ab, welche Angaben zu Daten Sie
        vor bzw. bei der Teilnahme an einem Webinar machen. Folgende
        personenbezogene Daten sind Gegenstand der Verarbeitung:
        <br />
        - Angaben zum Benutzer: Vorname, Nachname, Telefon (optional),
        E-Mail-Adresse, Passwort (wenn „Single-Sign-On“ nicht verwendet wird),
        Profilbild (optional),
        <br />
        - Bei Aufzeichnungen (optional): MP4-Datei aller Video-, Audio- und
        Präsentationsaufnahmen, M4A-Datei aller Audioaufnahmen, Textdatei des
        Online-Meeting-Chats.
        <br />
        - Bei Einwahl mit dem Telefon: Angabe zur eingehenden und ausgehenden
        Rufnummer, Ländername, Start- und Endzeit. Ggf. können weitere
        Verbindungsdaten wie z.B. die IP-Adresse des Geräts gespeichert werden.
        <br />
        - Text-, Audio- und Videodaten: Sie haben ggf. die Möglichkeit, in einem
        Webinar die Chat-, Fragen- oder Umfragenfunktionen zu nutzen. Insoweit
        werden die von Ihnen gemachten Texteingaben verarbeitet, um diese im
        Webinar anzuzeigen und ggf. zu protokollieren. Um die Anzeige von Video
        und die Wiedergabe von Audio zu ermöglichen, werden entsprechend während
        der Dauer des Meetings die Daten vom Mikrofon Ihres Endgeräts sowie von
        einer etwaigen Videokamera des Endgeräts verarbeitet. Sie können die
        Kamera oder das Mikrofon jederzeit selbst über die „Zoom“-Applikationen
        abschalten bzw. stummstellen.
        <br />
        <br />
        Um an einem Webinar teilzunehmen bzw. den „Meeting-Raum“ zu betreten,
        müssen Sie zumindest Angaben zu Ihrem Namen machen.
        <br />
        <br />
        2. Zweck der Datenverarbeitung Die Datenverarbeitung erfolgt zur
        Durchführung und Organisation unserer Webinare, zur Bereitstellung einer
        stabilen und qualitativ hochwertigen Verbindung sowie zur Interaktion
        mit den Teilnehmenden. Sofern das Webinar aufgezeichnet wird, erfolgt
        dies ausschließlich nach vorheriger Einwilligung der Teilnehmenden und
        dient der späteren Bereitstellung der Inhalte.
        <br />
        <br />
        3. Rechtsgrundlage Die Verarbeitung der Daten erfolgt auf Grundlage
        unseres berechtigten Interesses gemäß Art. 6 Abs. 1 lit. f DSGVO an der
        professionellen Durchführung von Webinaren. Sofern eine Aufzeichnung
        erfolgt, holen wir Ihre ausdrückliche Einwilligung gemäß Art. 6 Abs. 1
        lit. a DSGVO ein.
        <br />
        <br />
        4. Weitergabe und Übermittlung in Drittländer Zoom ist ein Dienst mit
        Sitz in den USA. Die Übermittlung der Daten erfolgt auf Grundlage von
        Standardvertragsklauseln, die den Schutz Ihrer Daten gewährleisten
        sollen. Zoom verpflichtet sich, Ihre Daten gemäß den europäischen
        Datenschutzvorgaben zu behandeln. Eine weitergehende Datenweitergabe an
        Dritte erfolgt nicht.
        <br />
        <br />
        5. Speicherdauer Ihre Daten werden nur solange gespeichert, wie dies zur
        Durchführung des Webinars und zur Erfüllung rechtlicher
        Aufbewahrungspflichten notwendig ist. Wenn Sie bei „Zoom“ als Benutzer
        registriert sind, dann können Berichte über Webinare (Meeting-Metadaten,
        Daten zur Telefoneinwahl, Fragen und Antworten in Webinaren,
        Umfragefunktion in Webinaren) bis zu 12 Monate bei „Zoom“ gespeichert
        werden. Eine automatisierte Entscheidungsfindung i.S.d. Art. 22 DSGVO
        kommt nicht zum Einsatz.
        <br />
        <br />
        Soweit personenbezogene Daten von Beschäftigten der Institut Wissen UG
        verarbeitet werden, ist Art. 6 Abs. 1 lit. b) DSGVO die Rechtsgrundlage
        der Datenverarbeitung.
      </span>
    </div>
    <div class="flex-c gap-8">
      <span class="title-level-3"> 3. SOCIAL MEDIA BUTTONS </span>
      <span class="font-regular-body-large">
        Facebook: Auf unserer Webseite bieten wir Ihnen die Möglichkeit, durch
        Anklicken eines Links auf unsere Facebook-Seite zu gelangen. Anbieter
        dieses Dienstes ist die Meta Platforms Ireland Limited, 4 Grand Canal
        Square, Dublin 2, Irland. Beachten Sie, dass dabei keine Daten an
        Facebook übertragen werden, solange Sie den Link nicht anklicken. Sobald
        Sie jedoch unsere Facebook-Seite besuchen, verarbeitet Facebook Ihre
        personenbezogenen Daten. Für Informationen zur Datenverarbeitung durch
        Facebook und deren Umfang verweisen wir auf die
        <a href="https://www.facebook.com/about/privacy/" target="_blank">
          Datenschutzerklärung von Facebook </a
        >. Wir haben keinen Einfluss auf die Datenverarbeitung durch Facebook.
        <br />
        <br />
        Instagram: Auf unserer Webseite finden Sie einen Link zu unserem Profil
        auf Instagram. Anbieter dieses Dienstes ist die Meta Platforms Ireland
        Limited, 4 Grand Canal Square, Dublin 2, Irland. Bitte beachten Sie,
        dass keine Daten an Instagram übertragen werden, solange Sie diesen Link
        nicht anklicken. Sobald Sie jedoch auf den Link klicken und unsere
        Instagram-Seite besuchen, verarbeitet Instagram Ihre personenbezogenen
        Daten. Für Informationen zur Datenverarbeitung durch Instagram und deren
        Umfang verweisen wir auf die
        <a href="https://privacycenter.instagram.com/policy/" target="_blank">
          Datenschutzerklärung von Instagram </a
        >. Wir haben keinen Einfluss auf die Datenverarbeitung durch Instagram.
        <br />
        <br />
        LinkedIn: Auf unserer Webseite bieten wir Ihnen die Möglichkeit, über
        einen Link auf unser Profil bei LinkedIn zu gelangen. Bitte beachten
        Sie, dass keine Daten an LinkedIn übertragen werden, solange Sie diesen
        Link nicht anklicken. Sobald Sie jedoch auf den Link klicken und unsere
        LinkedIn-Seite besuchen, verarbeitet LinkedIn Ihre personenbezogenen
        Daten. Für Informationen zur Datenverarbeitung durch LinkedIn und deren
        Umfang verweisen wir auf die
        <a href="https://www.linkedin.com/legal/privacy-policy" target="_blank">
          Datenschutzerklärung von LinkedIn </a
        >. Wir haben keinen Einfluss auf die Datenverarbeitung durch LinkedIn.
      </span>
    </div>
    <div class="flex-c gap-8">
      <span class="title-level-3"> 4. ENUVO GMBH (EVALUATION) </span>
      <span class="font-regular-body-large">
        Für die Durchführung der Evaluation nutzen wir das Tool
        <a href="https://www.umfrageonline.com/" target="_blank">
          https://www.umfrageonline.com/
        </a>
        der enuvo GmbH mit Sitz in der Schweiz (nachfolgend
        <span class="font-bold-body-large"> „enuvo“ </span>). Enuvo verarbeitet
        die von Ihnen im Rahmen einer Evaluation angegebenen und erhobenen
        personenbezogenen Daten auf Grundlage einer eines
        Auftragsverarbeitungsvertrages mit uns.
        <br />
        <br />
        Wenn Sie an einer Evaluation teilnehmen, erfasst enuvo Daten mithilfe
        von Cookies. Mithilfe dieser Cookies soll sichergestellt werden, dass
        der Umfrageservice uneingeschränkt bedienbar ist, damit die Umfragen wie
        vorgesehen und optimal ablaufen (bspw. um sicherzustellen, dass ein
        Umfrageteilnehmer nur einmal teilnehmen kann). Nach der Umfrageteilnahme
        ist es möglich, dass Sie auf die Website von enuvo weitergeleitet
        werden, wobei enuvo dann für eine etwaig weitere Datenverarbeitung
        allein verantwortlich ist.
        <br />
        <br />
        Daten, die via UmfrageOnline gesammelt werden (Teilnehmerantworten,
        etc.), werden ausschließlich in europäischen Rechenzentren (Irland
        und/oder Deutschland) von Amazon Web Services EMEA SARL (kurz «AWS»)
        gespeichert und verarbeitet. Unter Umständen werden Ihre
        personenbezogene Daten auch an Server von enuvo in der Schweiz
        übermittelt. Für eine etwaige Übermittlung von Daten die Schweiz hat die
        Europäische Kommission in einem Angemessenheitsbeschluss gemäß Art. 45
        DSGVO bestätigt, dass ein mit der DSGVO vergleichbares Datenschutzniveau
        besteht.
        <br />
        <br />
        Weitere Informationen zum Datenschutz bei enuvo finden Sie unter:
        <br />
        <a href="https://www.umfrageonline.com/datenschutz" target="_blank">
          https://www.umfrageonline.com/datenschutz</a
        >,
        <br />
        <a
          href="https://www.umfrageonline.com/auftragsverarbeitungsvertrag"
          target="_blank">
          https://www.umfrageonline.com/auftragsverarbeitungsvertrag</a
        >.
      </span>
    </div>
  </div>
</div>
